































































































































































import { defineComponent, ref } from '@vue/composition-api';
import moment from 'moment';
import { IBank } from '@/models';
import { useFetchBanks, useDeleteBank } from '@/composable/bank';
import authMixin from '@/mixins/auth';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import BankDialog from '@/components/bank/BankDialog.vue';
import BankDrawer from '@/components/bank/BankDrawer.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import BankOptionsButton from '@/components/bank/BankOptionsButton.vue';

export default defineComponent({
  name: 'BankListPage',
  mixins: [authMixin],
  components: {
    ALPage,
    ConfirmationDialog,
    ErrorAlert,
    BankDialog,
    BankDrawer,
    BankOptionsButton
  },
  setup(_) {
    //We use a separate ref for the search model in order to not update the queryKey once the search is updated
    const currentSearch = ref<string>('');

    const headers = [
      { text: 'Name', value: 'name', sortable: false },
      { text: 'Address', value: 'address', sortable: false },
      { text: 'Primary Phone #', value: 'phone1', sortable: false },
      { text: 'Secondary Phone #', value: 'phone2', sortable: false },
      { text: '', value: 'actions', sortable: false, width: 100 }
    ];

    const dialog = ref(false);
    const selectedBank = ref<IBank | null>(null);

    function openBankDialog(bank?: IBank) {
      dialog.value = true;
      selectedBank.value = bank ?? null;
    }

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deleteBank,
      reset: deleteReset
    } = useDeleteBank();

    const deleteDialog = ref(false);
    function openDeleteBankDialog(bank: IBank) {
      selectedBank.value = bank;
      deleteDialog.value = true;
    }

    function closeDrawerAndDialog() {
      drawer.value = false;
      deleteDialog.value = false;
    }

    function removeBank(vehicle: IBank) {
      deleteBank(vehicle.id!, {
        onSuccess: () => {
          closeDrawerAndDialog();
        }
      });
    }

    function clearAllErrors() {
      deleteReset();
      error.value = null;
    }

    const { banks, error, isLoading } = useFetchBanks();

    const drawer = ref(false);
    function openBankDrawer(bank: IBank) {
      selectedBank.value = bank;
      drawer.value = true;
    }

    return {
      deleteInProgress,
      deleteDialog,
      deleteError,
      drawer,
      selectedBank,
      moment,
      dialog,
      currentSearch,
      banks,
      isLoading,
      headers,
      error,
      openBankDialog,
      clearAllErrors,
      openDeleteBankDialog,
      openBankDrawer,
      closeDrawerAndDialog,
      removeBank
    };
  }
});
